export const escapeReservedUrlCharacters = string => {
  return string.replace(/,/g, '%5C%2C').replace(/&/g, '%26')
}

/**
 *
 * @param {*} string: string
 * @param {*} replace: string
 * @param {*} except: array of string
 * @returns {*} string
 */
export const removeSpecialCharacters = ({ string, replace, except }) => {
  const expression = new RegExp(`[^0-9a-zA-ZÀ-ÿ${except.join('')} ]`, 'g')
  return string.replace(expression, replace).trim()
}



// WEBPACK FOOTER //
// ./src/utils/escape.js